import { useTranslation } from "react-i18next";
import {
  FormSection,
  FormSectionStack,
  RepeatableList,
} from "@/features/admin/components";
import { CatalogSelectField } from "@/features/admin/catalog";

/**
 * ═══════════════════════════════════════════════════════════════════
 * Paso 5 · Beneficios, y solo beneficios.
 *
 * ── El eslogan ya no se edita aquí (26-ago, segunda pasada) ─────────
 * Anahí dictó que este paso lleva los beneficios y nada más. El
 * eslogan (`translations.<idioma>.tagline`) sigue en el contrato y en
 * los valores del formulario —un producto que lo tenga escrito no lo
 * pierde al guardar—, solo se quedó sin control en el asistente.
 *
 * ── Los beneficios son un CATÁLOGO ──────────────────────────────────
 * Eran texto libre dentro de `translations.<idioma>.benefits`: dos
 * listas paralelas, una por idioma, que nada obligaba a mantener
 * emparejadas. Ahora un beneficio es una ENTIDAD del catálogo con su
 * texto en los dos idiomas, y el producto guarda a cuáles se acoge. Se
 * escribe una vez y se corrige una vez. Es el MISMO `CatalogSelectField`
 * del paso 2, con el `kind` cambiado.
 *
 * ── Por qué una LISTA y no un selector múltiple ─────────────────────
 * Porque el ORDEN es información. El primer beneficio es el que se lee
 * siempre; el sexto, casi nunca. Un multiselector devuelve un conjunto
 * y el orden se lo tendría que inventar el catálogo, que es una
 * decisión compartida por todos los productos. Aquí cada fila sube y
 * baja.
 * ═══════════════════════════════════════════════════════════════════
 */
export function BenefitsStep() {
  const { t } = useTranslation();

  return (
    <FormSectionStack>
      <FormSection
        title={t("Beneficios")}
        description={t(
          "Se eligen de una lista compartida, y cada uno trae ya su texto en español y en inglés. Si falta alguno, se añade aquí mismo.",
        )}
        columns={1}
        compact
        aside={<span className="text-[12px] text-ds-ink-3">{t("Caben hasta 12.")}</span>}
      >
        <RepeatableList
          name="benefits"
          max={12}
          addLabel={t("Añadir beneficio")}
          itemLabel={(index) => t("Beneficio {{n}}", { n: index + 1 })}
          emptyHint={t("Todavía no hay beneficios. Añade el primero.")}
          newItem={() => ({ value: "" })}
        >
          {({ name }) => (
            <CatalogSelectField
              name={`${name}.value`}
              kind="benefit"
              label={t("Beneficio")}
              placeholder={t("Elige…")}
              addLabel={t("Crear uno nuevo")}
            />
          )}
        </RepeatableList>
      </FormSection>
    </FormSectionStack>
  );
}
